export default __webpack_public_path__ + "static/media/116-BU-110N.e1c3df80.png";